import { CarClass } from "Enums/CarClass";

export class InitializedCar {
  public descriptionEnglish: string | null = null;
  public descriptionPortuguese: string | null = null;
  public class: CarClass = CarClass.minor;
  public score: number | null = null;
  public createdAt: Date | null = null;
}
